import creator from '../helpers/creator'
import Tabs from './Tabs'
import Video from './Video'
import Search from './Search'

class Fetch {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$overlayChild = [...document.querySelectorAll('.js-overlay-child')]
    this.items = []
    this.lang = document.documentElement.lang
  }

  bindEvents() {
    window.addEventListener('load', this.onLoad.bind(this))
  }

  onLoad() {
    for (let i = 0; i < this.ui.$overlayChild.length; i++) {
      let url = this.ui.$overlayChild[i].getAttribute('data-url')
      let id = this.ui.$overlayChild[i].getAttribute('data-id')

      this.items.push({
        id,
        url
      })
    }

    this.fetchData()
  }

  async fetchData() {
    let myHeaders = new Headers()
    myHeaders.append("x-custom-provider", "dior-montaigne")

    // remove duplicates
    this.items = this.items.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.url === value.url
        ))
    )

    let promise = await Promise.all(this.items.map((item, index) => fetch(item.url, {headers: myHeaders})
      .then(response => response.text())
      .then(html => {
        // Convert the HTML string into a document object
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        let content = doc.querySelector('body').innerHTML
        let overlays = document.querySelectorAll(`.js-overlay-child[data-id="${this.items[index].id}"]`)
        for (let i = 0; i < overlays.length; i++) {
          overlays[i].innerHTML = content
        }
      })
      .then(() => {
        window.tabs = creator('.js-tabs', Tabs)
        window.video = creator('.js-card', Video)
        window.search = new Search()
      })
      .catch(err => {
        console.error('Failed to fetch one or more of these URLs:');
        console.log(this.items);
        console.error(err);
      })
    ))
    .then(() => {
      const event = new CustomEvent("fetch:done")

      setTimeout(() => {
        window.dispatchEvent(event)
      }, 100)
    })
    .catch(err => {
      console.error(err);
    })

  }
}

export default Fetch
